<template>
  <div class="pt-2 width-100">
    <template v-if="loading">
      <v-skeleton-loader
        :boilerplate="false"
        class="pt-4 pl-5"
        style="height: 40px;"
        :tile="false"
        type="text"
        width="100%"/>
      <v-skeleton-loader
        v-if="mutableOptions.descriptionShow"
        :boilerplate="false"
        class="pt-4 pl-5"
        :tile="false"
        type="text"
        width="100%"/>
    </template>
    <div
      v-else
      class="width-100 grid gap-4"
      style="grid-template-columns: minmax(205px, 1fr) auto;">
      <div
        class="text-left max-width-100">
        <div
          class="flex gap-2 align-center">
          <slot name="title-actions"/>
          <slot name="title">
            <TooltipedText
              v-if="title"
              class="h1-headline"
              :line-count="1"
              :line-height="1.15"
              :value="title"/>
          </slot>
        </div>
        <TooltipedText
          v-if="description"
          class="h8-text mt-4"
          :line-count="3"
          :line-height="1.15"
          :value="description"/>
      </div>
      <slot/>
    </div>
  </div>
</template>
<script>
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'

import { componentOptions} from 'mixins'

export default {
  name: 'TemplateItemTitle',
  mixins: [ componentOptions],
  data() {
    return {
      open: false,
      mutableOptions: {
        titleField: 'title',
        titleDefaultLabel: this.$t('Catalog.NewPurchase'),
        descriptionField: 'description',
        descriptionShow: false
      },
    }
  },
  computed: {
    title() {
      return this.item ? this.item[this.mutableOptions.titleField] : this.mutableOptions.titleDefaultLabel
    },
    description() {
      if (!this.mutableOptions.descriptionShow) {
        return null
      }
      return this.item ? this.item[this.mutableOptions.descriptionField] : null
    },
  },
  components: {
    TooltipedText,
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
}
</script>
